import icons from './icons'

/**
 * Creates a slotted title with the municipality name.
 * @param {string} title Name of the municipality.
 * @returns {HTMLElement}
 */
export const createListItemTitle = title => {
    const titleElement = document.createElement('h4')
    titleElement.className = 'municipality-item-title'
    titleElement.slot = 'title'
    titleElement.textContent = title
    return titleElement
}

/**
 * Creates a slotted paragraph with the county name.
 * @param {string} county Name of the county.
 * @returns HTMLElement
 */
export const createListItemCounty = county => {
    const paragraph = document.createElement('p')
    paragraph.className = 'municipality-item-county'
    paragraph.slot = 'county'
    paragraph.textContent = county
    return paragraph
}

/**
 * Creates a link with an icon an title.
 * @param {string} title Title of the department.
 * @param {(string|URL)} link URL to navigate to.
 * @param {string} type Icon type to use.
 * @returns {HTMLElement}
 */
export const createListItemDepartment = (title, link, type) => {
    const anchor = document.createElement('a')
    anchor.className = 'municipality-item-department'
    anchor.href = link
    anchor.title = title
    anchor.target = '_blank'
    anchor.slot = 'department'

    const icon = icons[type]
    const faIcon = document.createElement('i')
    faIcon.className = 'fas'
    faIcon.classList.add(icon)

    const titleElement = document.createElement('span')
    titleElement.textContent = title

    anchor.append(faIcon, titleElement)
    return anchor
}



// WEBPACK FOOTER //
// ./scripts/web-components/municipality-picker-list/util.js